import {getCurrentLang, getCurrentLangDirection} from '../components/langSwitcher/langSwitcher';
import {  isDesktop, isMobile, isNoMenu, projectMode, settingsData, threeJsVariables, UIRoot, TRoot } from '../../settings';
import {CSS2DObject} from '../../libs/CSS2DRenderer';
import { createHtmlElement, isOneMesh, labelVisibility, rgbaToHexA } from '../../functions';
import {Drag} from "../interfaces/Drag";
import {Group, LineBasicMaterial, Raycaster, BufferGeometry, Line, MeshBasicMaterial, Frustum, Matrix4} from 'three';
import {Vector3} from 'three';
import {ViewMode} from '../../common';
import {
	buildInfoWindowContent,
	buildInfoWindowMobileContent,
	checkPoiResponse,
	closePrevInfoWindow,
	getPlacePhoto,
	map,
	openMiniCard,
	openMiniCardFullscreen,
	resetMapRenderer,
	setMobileFullscreenCardSize,
	smoothlyAnimatePanTo,
	Swipe,
} from '../widgets/poi/poiv3';
import {mobileBurgerStyleToggle, pageResize} from '../menu/menu';
import gsap from "gsap";
import {PublicLayers} from '../components/publicLayers/PublicLayers';
import {latLngAltToVector3} from '../components/publicLayers/Layer';
import {PoiLayer} from '../components/publicLayers/PoiLayer';
import {Terrain} from '../components/Terrain/Terrain';
import {Environment} from '../components/Environment/Environment';
import {Cloudflare} from '../api/Cloudflare';
import {BaseElement} from "../interfaces/BaseElement";
import {mobileBuildingLabelsHideLogic} from "../components/building-switch/buildingLabels";

const poiRaycaster = new Raycaster();
poiRaycaster.firstHitOnly = true;
// let drag = null;
let swipe = null;
const INTERSECTIONS = [];
const LABELS = [];
let POI = [];

export function addBuildingsIntersections(model) {
	if (!isOneMesh() && !model) {
		INTERSECTIONS.push(...settingsData.objects_to_intersection);
	} else if (model){
		INTERSECTIONS.push(model);
	}
	poiIntersection();
}

export function isBuildingIntersectionsSet() {
	return INTERSECTIONS.length;
}

export function addPoiToIntersection(label) {
	POI.push(label);
	poiIntersection();
}

export function removePoiFromIntersection(label) {
	POI = POI.filter(poi => poi !== label);
}

export function initPoiData(response) {
	if (!config.features.poi.active || projectMode.LiteMode.isActive())
		return;

	const [poi, poiCategories, poiSettings] = response;
	const poiData = poi.data;
	const poiCategoriesData = poiCategories.data;
	const poiSettingsData = poiSettings.data;
	const hide = config.features.poi.hide;

	if (!checkPoiResponse(poiData, poiCategoriesData))
		return;

	addPoiToCategory(poiCategoriesData, poiData, poiSettingsData);
	addPoiOnScene(poiCategoriesData);

	if (poiData.some(el => el.orbit === 1)) {
		if (PublicLayers.isActive) {
			const poisLayer = new PoiLayer(document.querySelector('.public-layers__elements'));
			!PublicLayers.activeLayer && poisLayer.show();
			PublicLayers.addLayer(poisLayer);
			!PublicLayers.activeLayer && (PublicLayers.activeLayer = poisLayer);
		} else if (Environment.isActive()) {
			setTimeout(() => {
				const poisLayer = new PoiLayer(document.querySelector('.public-layers__elements'));
				!Environment.getActivePublicLayer() && poisLayer.show();
				Environment.addCustomLayer('poi', poisLayer);
				!Environment.getActivePublicLayer() && Environment.setActivePublicLayer(poisLayer);
			}, 500);
		}
	}

	hide && addBuildingsIntersections();
	poiIntersection();
	mobileBuildingLabelsHideLogic();
}

function addPoiOnScene(categories) {
	const rotation = new Vector3();
	const scale = new Vector3(1,1,1);

	if (config.features.poi.rotation) {
		rotation.set(
			config.features.poi.rotation.x,
			config.features.poi.rotation.y,
			config.features.poi.rotation.z
		)
	} else {
		rotation.y = config.threejs.compass.correction - Math.PI / 2;
	}

	if (config.features.poi.scale) {
		scale.set(
			config.features.poi.scale.x,
			config.features.poi.scale.y,
			config.features.poi.scale.z
		)
	}
	
	// if (projectMode.AirMode.active) {
	// 	rotation.y = 0;
	// }

	const position = config.features.poi.position || {x: 0, y: 0, z: 0};
	const poiGroup = new Group();
	poiGroup.name = 'Poi group';
	poiGroup.rotation.setFromVector3(rotation);
	poiGroup.position.set(position.x, 0, position.z);
	poiGroup.scale.copy(scale);

	categories.forEach(category => {
		const categoryColor = category.color;
		category.data.forEach(poi => {
			if (poi.orbit === 1) {
				const label = createPoiLabel(poi, categoryColor, category);
				poiGroup.add(label);
				POI.push(label.getObjectByName('poi label'));
			}
		});
	});

	poiGroup.children.sort((prev, next) => prev.userData.order - next.userData.order);
	threeJsVariables.scene.add(poiGroup);
	threeJsVariables.renderList.reorder();
	animatePoi(poiGroup);
	poiIntersection();

	if (settingsData.activeViewMode !== ViewMode.Orbit)
		poiToggle(false);
}

function animatePoi(group) {
	let count = 0.5;
	const lineDuration = 1;
	const labelDuration = 0.2;

	const tl = gsap.timeline({paused: true});

	group.traverse(el => {
		if (el.name === 'poi') {
			const line = el.getObjectByName('poi line');
			const label = el.getObjectByName('poi label');

			const lineAnimation = gsap.fromTo(line.position, {
				y: -300
			}, {
				y: line.position.y,
				duration: lineDuration,
				delay: count,
				onStart: () => {
					if (settingsData.activeModeSwitching || settingsData.activeViewMode !== ViewMode.Orbit) {
						poiToggle(false);
					}
				},
				onComplete: () => line.material.opacity = 1
			});


			const labelAnimation = gsap.to(label.element, {
				opacity: 1,
				duration: labelDuration,
				delay: count + lineDuration - labelDuration,
				onComplete: () => {
					label.element.style.opacity = '';
				}
			});

			tl.add(lineAnimation, 0);
			tl.add(labelAnimation, 0);

			count += 0.5;
		}
	});

	tl.play(0);
}

function createPoiLabel(poi, categoryColor, category) {
	const hide = config.features.poi.hide;
	const lineStart = typeof config.features.poi.lineStart === 'number' ? config.features.poi.lineStart : projectMode.AirMode.active && poi.hasOwnProperty('elevation') ? poi.elevation : -500;
	const poiGroup = new Group();
	poiGroup.name = 'poi';
	poiGroup.userData.distance = poi.distance;
	poiGroup.userData.order = poi.order;

	const designType = config.features?.poi?.designType;
	const customColors = config.features?.poi?.colors;
	let lineColor = 0xffffff;


	if (designType === 'flat-sign' && !isMobile) {
		if (customColors && customColors.line) {
			lineColor = customColors.line;
		} else {
			const brandColor = document.querySelector(':root').style.getPropertyValue('--brand1');
			// trunc rgba(x,x,x,x) color to x,x,x,x then makes it array [x,x,x,x] and exec in rgbaToHexA
			lineColor = rgbaToHexA(
				brandColor
					.replace("rgba(", "")
					.replace(")", "")
					.split(','),
				false
			);
		}
	}

	const heightCorrection = (poi) => {
		const poisForCorrection = config.features.poi?.poisForHeightCorrection;
		if (!poisForCorrection || poisForCorrection.length === 0)
			return 0;

		let correction = 0;
		poisForCorrection.forEach(item => {
			if (item.id === poi.id) {
				correction = parseInt(item.correction);
			}

		});
		return correction;
	}

	const lineMaterial = new LineBasicMaterial({color: lineColor, transparent: true, depthWrite: true});
	
	let lineS = new Vector3(poi.coords3dScene.x, lineStart, poi.coords3dScene.z);
	let lineE = new Vector3(poi.coords3dScene.x, poi.coords3dScene.y + heightCorrection(poi), poi.coords3dScene.z);
	
	// if (projectMode.AirMode.active) {
	// 	const vec = projectMode.AirMode.project({lat: Number(poi.latitude), lng: Number(poi.longitude),altitude: 0});
	// 	lineS.copy(vec);
	// 	lineE.copy(vec).add(new Vector3(0,poi.coords3dScene.y,0));
	// }
	
	const lineGeomerty = new BufferGeometry().setFromPoints([
		lineS,
		lineE
	]);
	const line = new Line(lineGeomerty, lineMaterial);
	if (projectMode.AirMode.active) {
		lineMaterial.depthTest = false;
		lineMaterial.opacity = 0;
	}
	
	line.name = 'poi line';

	const name = poi.name.filter(el => el.lang === getCurrentLang())[0].value;
	const poiContainer = document.createElement('div');
	poiContainer.classList.add('poi__label');

	if (projectMode.LiteMode.isActive())
		poiContainer.classList.add('lite-mode__line');

	poiContainer.setAttribute('data-latitude', poi.latitude);
	poiContainer.setAttribute('data-longitude', poi.longitude);


	const poiText = new BaseElement('span')
		.addClass('poi__title', 'language-string', isMobile  ? 'hidden' : null)
		.innerHtml(name)
		.appendTo(poiContainer);

	if (!isMobile && designType !== 'flat-sign' ) {
		poiText.addClass('invisible');
		poiContainer.addEventListener('mouseenter',() => poiText.removeClass('invisible'));
		poiContainer.addEventListener('mouseleave',() => poiText.addClass('invisible'));
	}

	poi.name.forEach(obj => {
		poiText.addAttribute(`data-lang-${obj.lang}`, obj.value);
	});


	if (designType === 'flat-sign' && !isMobile) {
		poiContainer.classList.add(designType);

		if (customColors) {
			if (customColors.bg) {
				poiText.addStyle('background',customColors.bg);
			}
			if (customColors.text) {
				poiText.addStyle('color',customColors.text);
			}
		}
	}


	function addPlaceholderImage() {
		new BaseElement()
			.addClass('poi__icon', designType === 'flat-sign' && !isMobile ? 'hidden' : null)
			.addStyle('background-image', `url(/img/icons/poi/${category.iconMenu}.svg)`)
			.addStyle('background-color', categoryColor)
			.appendTo(poiContainer);
	}

	function loadImage(link) {
		const mapMarker = settingsData.mapMarkers.allPoiMarkersWithoutCategory.filter(marker => marker.title === name)[0];
		if (link) {
			addPlaceholderImage();
			mapMarker.data.sendPhotoRequest = true;
			mapMarker.data.infoWindowImg = link;
			// const i = new Image();
			// i.onload = () => {
			// 	i.classList.add('poi__icon');
			// 	if (designType === 'flat-sign')
			// 		i.classList.add('hidden');
			// 	poiContainer.appendChild(i);
			// 	mapMarker.data.infoWindowImg = link;
			// };
			// i.onerror = () => {
			// 	addPlaceholderImage();
			// };
			// i.src = link;
		} else {
			addPlaceholderImage();
		}
	}

	/*if (isMobile || designType === 'flat-sign') {
		addPlaceholderImage();
	} else*/ if (poi.customImage.trim().length) {
		loadImage(Cloudflare.resize(poi.customImage, {
			width: 255
		}));
	} else {
		loadImage();
		// const placePhoto = getPlacePhoto(poi, {maxHeight: 255, maxWidth: 255});
		// placePhoto.then(img => loadImage(img));
	}

	const label = new CSS2DObject(poiContainer);
	label.name = 'poi label';
	label.material = new MeshBasicMaterial({color: 0xffffff});
	label.position.copy(lineE);
	label.userData.zoom = 1;
	label.userData.coords = {lat: Number(poi.latitude), lng: Number(poi.longitude),altitude: 0};
	label.element.style.opacity = 0;

	LABELS.push({
		label,
		line,
		distance: poi.distance
	});

	poiGroup.add(label);
	poiGroup.add(line);
	lineGeomerty.dispose();
	lineMaterial.dispose();

	return poiGroup;
}

export function hidePOILabelsByDistance (state) {
	const labels = LABELS.filter(label => label.distance > 400);
	labels.forEach(data => labelVisibility(data,state));
}

function addPoiToCategory(categories, poiData, mainBuildingData) {
	const terrain = new Terrain();
	poiData.forEach(poi => {
		const {coords, distance, altitude} = calcPoiCoordsAndDistance(poi, mainBuildingData, terrain);
		poi.coords3dScene = coords;
		poi.origin3dCoords = new Vector3().copy(coords);
		poi.distance = distance;
		poi.altitude = altitude;
	});

	poiData.sort((prev, next) => prev.distance - next.distance);

	let {position, distanceCoefficientCorrection} = config.features.poi;
	if (distanceCoefficientCorrection === undefined)
		distanceCoefficientCorrection = 5;
	poiData.forEach(poi => {
		poi.coords3dScene.y = (position?.y || 0) + poi.altitude + poi.distance / distanceCoefficientCorrection;
	});

	categories.forEach(category => {
		category.data = [];
		poiData.forEach(poi => {
			if (Number(category.categoryId) === poi.categoryId) {
				category.data.push(poi);
			}
		});
	});
}

// export function poiLineUpdate (visible = true) {
//   const poiGroup = threeJsVariables.scene.getObjectByName('Poi group');
//   poiGroup.traverse(el =>{
//     if (el.name === 'poi line'){
//       el.visible = visible;
//     }
//   });
// }

export function cssPoiHandler(e) {
	let target = e.target;
	if (!config.features.poi.active)
		return;

	if (target.classList.contains('poi__icon') || target.classList.contains('poi__title')) {
		target = target.parentElement;
	} else if (!target.classList.contains('poi__label')) {
		return;
	}

	if (target.classList.contains('hide__label'))
		return;

	openMarkerInfoWindowInOrbit(target, e);
}

export function poiOrbitCardSwitchingLang() {
	const openedCard = document.querySelector('.poi__info-window');
	if (!openedCard)
		return;

	const title = openedCard.getAttribute('data-poi-title');
	const poiLabel = document.querySelector(`.poi__title[data-lang-en="${title}"]`);
	const element = poiLabel.parentElement;

	openedCard.remove();

	const clickObj = {
		clientX: element.getBoundingClientRect().x,
		clientY: element.getBoundingClientRect().y
	};

	openMarkerInfoWindowInOrbit(element, clickObj);
}

// function calcPoiCoords (poi,buildingPoi,poiY) {
//   const poiLatitude = Number(poi.coords3d.x);
//   const poiLongitude = Number(poi.coords3d.y);
//   const latKmConstant = 111.134861111 * 1000;
//   const lonKmConstant = (111.321377778 * Math.cos(poiLatitude)) * 1000;
//
//   const {latitude,longitude} = buildingPoi;
//
//   const posX = (latitude - poiLatitude) * latKmConstant;
//   const posZ = (longitude - poiLongitude) * lonKmConstant;
//
//   return new THREE.Vector3(posX,poiY,posZ);
// }

export function calcPoiCoordsAndDistance(poi, buildingPoi, terrain) {
	const point = latLngAltToVector3(
		{lat: Number(poi.coords3d.x), lng: Number(poi.coords3d.y)},
		{lat: buildingPoi.latitude, lng: buildingPoi.longitude}
	);

	const intersectionVector = new Vector3().copy(point);
	const axis = new Vector3(0, 1, 0).normalize();
	const angle = config.features.poi.rotation?.y || 0;
	const poisPosition = config.features.poi.position;
	const position = new Vector3(0, 0, 0);
	if (poisPosition) {
		position.set(poisPosition.x, poisPosition.y, poisPosition.z);
	}

	intersectionVector.applyAxisAngle(axis, angle);
	intersectionVector.add(position);

	const height = config.features.poi.preventRaycasting ? 0 : terrain.intersectHeightFromVector3(intersectionVector);
	const distance = new Vector3().distanceTo(point);

	return {
		coords: point,
		distance: distance,
		altitude: height
	};
}

// function getLengthOfDegree (coords) {
//   const length = {};
//
//   // Latitude
//   if (coords.lat > 0 && coords.lat < 15){
//     length.latKm = 110.574;
//   } else if (coords.lat >= 15 && coords.lat < 30){
//     length.latKm = 110.649;
//   } else if (coords.lat >=30 && coords.lat < 45){
//     length.latKm = 110.852;
//   } else if (coords.lat >=45 && coords.lat < 60){
//     length.latKm = 111.133;
//   } else if (coords.lat >=60 && coords.lat < 75){
//     length.latKm = 111.412;
//   } else if (coords.lat >=75 && coords.lat < 90){
//     length.latKm = 111.618;
//   } else if (coords.lat >=90){
//     length.latKm = 111.694;
//   }
//
//   // Longitude
//   if (coords.lng > 0 && coords.lng < 15){
//     length.lngKm = 111.320;
//   } else if (coords.lng >=15 && coords.lng < 30){
//     length.lngKm = 107.551;
//   } else if (coords.lng >=30 && coords.lng < 45){
//     length.lngKm = 96.486;
//   } else if (coords.lng >=45 && coords.lng < 60){
//     length.lngKm = 78.847;
//   } else if (coords.lng >=60 && coords.lng < 75){
//     length.lngKm = 55.800;
//   } else if (coords.lng >=75 && coords.lng < 90){
//     length.lngKm = 28.902;
//   } else if (coords.lng >=90){
//     length.lngKm = 0;
//   }
//
//   return length;
// }

const worldPosition = new Vector3();
const worldPositionCopy = new Vector3();
const cameraMatrix = new Matrix4();
const poiFrustum = new Frustum();
let intersects = [];
let poiInFieldOfView = null;

export function poiIntersection() {
  const isPoiActive = config.features.poi.active;
  const isLiteModeActive = projectMode.LiteMode.isActive();
  const isModeNotOrbit = settingsData.activeViewMode !== ViewMode.Orbit;
  if (!isPoiActive || isLiteModeActive || isModeNotOrbit || projectMode.AirMode.active)
    return;

  cameraMatrix.multiplyMatrices(
    threeJsVariables.perspectiveCamera.projectionMatrix,
    threeJsVariables.perspectiveCamera.matrixWorldInverse
  );
  poiFrustum.setFromProjectionMatrix(cameraMatrix);

	const POI_DESIGN = config.features.poi?.designType;
	let amountOfPoiInFOV = 0;
	const listOfPoiToCheck = [
		'poi__label'
	];

	POI.forEach(label => {
		label.getWorldPosition(worldPosition);
		poiInFieldOfView = poiFrustum.containsPoint(worldPosition);

		if (config.features.poi.hide) {
			if (poiInFieldOfView) {
				worldPositionCopy.copy(worldPosition);
				worldPosition.project(threeJsVariables.perspectiveCamera);

				poiRaycaster.setFromCamera(worldPosition, threeJsVariables.perspectiveCamera);
				intersects = poiRaycaster.intersectObjects(INTERSECTIONS);

				const mobileBuildingLabelsHideLogic = label.element.getAttribute('mobile-hide-logic');
				if (intersects.length === 0 && mobileBuildingLabelsHideLogic !== 'hide') {
					label.element.classList.remove('hide__label');
				} else {
					const originIntersectionRule = intersects.length > 0 && (intersects[0].distance < worldPositionCopy.distanceTo(threeJsVariables.perspectiveCamera.position));
					if (originIntersectionRule || mobileBuildingLabelsHideLogic === 'hide') {
						label.element.classList.add('hide__label');
					} else {
						label.element.classList.remove('hide__label');
					}
				}
			}
		}

		const isAllowedPoiType = listOfPoiToCheck.some(className => label.element.classList.contains(className))
		if (isMobile && isAllowedPoiType) {
			if (poiInFieldOfView)
				amountOfPoiInFOV++;

			if (POI_DESIGN !== 'flat-sign' && poiInFieldOfView) {
				const labelTitleElement = label.element.querySelector('.poi__title');
				if (calculatePOIDistanceToCamera(label) < (config.features.poi?.titleShowDistance || 50)) {
					labelTitleElement.classList.remove('hidden');
				} else {
					labelTitleElement.classList.add('hidden');
				}
			}

			if (POI_DESIGN === 'flat-sign' && amountOfPoiInFOV > 3 || POI_DESIGN !== 'flat-sign' && amountOfPoiInFOV > 5) {
				label.parent.children[1].visible = false;
				// label.element.classList.add('hide__label');
				label.element.setAttribute('hide-by-amount', true);
			} else {
				label.parent.children[1].visible = true;
				// label.element.classList.remove('hide__label');
				label.element.setAttribute('hide-by-amount', false);
			}
		}
	});
}

function calculatePOIDistanceToCamera(css2DObject) {
	const css2DObjectPosition = new Vector3();
	css2DObject.getWorldPosition(css2DObjectPosition);
	const cameraPosition = threeJsVariables.perspectiveCamera.position;
	return cameraPosition.distanceTo(css2DObjectPosition);
}

export function poiToggle(visible, layerVisible) {
	if (!config.features.poi.active)
		return;

	const group = threeJsVariables.scene.getObjectByName('Poi group');
	if (!group)
		return;


	if ((visible && PublicLayers.isActive && !layerVisible) || (visible && Environment.isActive() && !layerVisible)) {
		return;
	}

	// if (group.visible === visible){
	//   return;
	// }

	group.traverse(el => {
		if (el.name !== 'poi anchor1' && el.name !== 'poi anchor2') {
			el.visible = visible;
		}
	});

	visible && poiIntersection();
}

export function dealsToggle(visible) {
	const group = threeJsVariables.scene.getObjectByName('Deals group');
	if (!group)
		return;

	group.traverse(el => {
		el.visible = visible;
	});

	visible && poiIntersection();
}

export function openMarkerInfoWindowInOrbit(element, e) {
	const title = element.querySelector('.poi__title').getAttribute('data-lang-en');
	const poiName = element.textContent;
	const poiImg = element.querySelector('.poi__icon');
	const poiData = config.poiData.find(poi => poi.name.find(name => name.value === poiName));
	const poiMarker = settingsData.mapMarkers.allPoiMarkersWithoutCategory.find(marker => marker.title === poiName);
	if (!poiMarker || !poiData) return;
	poiMarker.data['360'] = poiData['360'];
	poiMarker.data['customImage'] = poiData['customImage'];
	let infoCardContainer;

	const infoWindow = document.querySelector('.poi__info-window');
	infoWindow && closePoiInfoWindowCardInOrbit();

	const mainContainer = createHtmlElement(UIRoot, '', 'div', ['poi__info-window']);
	mainContainer.setAttribute('data-poi-title', title);
	if (isNoMenu)
		mainContainer.classList.add('no-menu-mode');

	if (poiImg && poiImg.tagName !== 'DIV')
		poiMarker.data.infoWindowImg = poiImg.src;

	if (isMobile) {
		infoCardContainer = buildInfoWindowMobileContent(poiMarker, true);
		addLanguageContent(infoCardContainer, poiData);
		mainContainer.appendChild(infoCardContainer);
		swipe = new Swipe(mainContainer);
		setPoiCardSwipeFunctions(swipe, poiMarker, mainContainer);

		setTimeout(() => {
			openMiniCard(mainContainer, false, true);
		}, 100);

	} else {
		infoCardContainer = buildInfoWindowContent(poiMarker, true);
		addLanguageContent(infoCardContainer, poiData);
		mainContainer.appendChild(infoCardContainer);
		calculateAndSetCardPosition(mainContainer, e);
		poiCardAnimation('open');
		new Drag(mainContainer, {
			updateElementPositionAfterDragEnd: true,
			touchSupport: true
		});
	}

	// Draw route
	if (!config.features.poi?.hideRoutes && !isMobile) {
		let poiLayer;
		if (Environment.isActive()) {
			poiLayer = Environment.getLayer('poi');
		} else {
			poiLayer = PublicLayers.getLayer('poi');
		}
		poiLayer && poiLayer.drawRoute(poiMarker, poiData.order);
	}
}

export function resizeOrbitPoiCard() {
	if (!isMobile)
		return;

	const card = document.querySelector('.poi__info-window');
	if (!card)
		return;

	if (!settingsData.isLandscape && !card.classList.contains('orbit__mode')) {
		card.firstElementChild.style.maxWidth = 'unset';
		card.firstElementChild.style.width = '100%';
	}
	const poiMarker = settingsData.mapMarkers.allPoiMarkersWithoutCategory.filter(marker => marker.title === card.getAttribute('data-poi-title'))[0];

	card.classList.contains('orbit__mode') ?
		setMobileFullscreenCardSize(true) :
		openMiniCard(card, false, true);

	setPoiCardSwipeFunctions(swipe, poiMarker, card);
}

export function setActiveRouteInOrbitCard(route) {
	const orbitCard = document.querySelector('.poi__info-window');
	if (orbitCard) {
		const routeContainer = orbitCard.querySelector(`.route[data-route-type="${route}"]`);
		routeContainer && routeContainer.classList.add('active-route');
	}
}

export function resetOrbitActiveRoute() {
	const orbitCard = document.querySelector('.poi__info-window');
	if (orbitCard) {
		const activeOrbitRoute = orbitCard.querySelector('.route.active-route');
		activeOrbitRoute && activeOrbitRoute.classList.remove('active-route');
	}
}

function addLanguageContent(element, poiData) {
	const category = config.poiCategories.filter(category => parseInt(category.categoryId) === poiData.categoryId)[0];
	const categoryTitle = element.querySelector('.snazzy-content__category-title');
	const times = element.querySelectorAll('.snazzy-content__time-route');
	const streetView = element.querySelector('.snazzy-content__street-view');
	const title = element.querySelector('.snazzy-content__title');
	const description = element.querySelector('.snazzy-content__description');
	const address = element.querySelector('.snazzy-content__address');

	categoryTitle.classList.add('language-string');
	categoryTitle.setAttribute('data-dictionary', category.name.filter(name => name.lang === 'en')[0].value);

	if (streetView) {
		streetView.classList.add('language-string');
		streetView.setAttribute('data-dictionary', config.dictionary['Street view'].en);
	}

	title.classList.add('language-string');
	address.classList.add('language-string');
	description.classList.add('language-string');

	poiData.name.forEach(obj => {
		title.setAttribute(`data-lang-${obj.lang}`, obj.value);
	});

	poiData.address.forEach(obj => {
		address.setAttribute(`data-lang-${obj.lang}`, obj.value);
	});

	poiData.description.forEach(obj => {
		description.setAttribute(`data-lang-${obj.lang}`, obj.value);
	});

	for (let time of times) {
		time.classList.add('language-string');
		time.setAttribute('data-dictionary-parse', 'mins');
	}
}

function calculateAndSetCardPosition(container, event) {
	let left, top;

	const direction = getCurrentLangDirection();

	let menuWidth = 0;
	const asideMenuWidth = document.querySelector('.aside__container');
	if (asideMenuWidth)
		menuWidth = parseFloat(asideMenuWidth.dataset.initialWidth);

	const width = container.getBoundingClientRect().width;
	const height = container.getBoundingClientRect().height;
	const halfCardWidth = width / 2;
	const halfCardHeight = height / 2;
	const eventX = event.clientX;
	const eventY = event.clientY;
	const cardCenterX = eventX - halfCardWidth;
	const cardCenterY = eventY - halfCardHeight;

	const windowSize = {
		minX: (direction === 'ltr') ? menuWidth : 0,
		maxX: (direction === 'ltr') ? window.innerWidth : window.innerWidth - menuWidth,
		minY: 0,
		maxY: window.innerHeight
	};

	const cardSize = {
		minX: eventX - halfCardWidth,
		maxX: eventX + halfCardWidth,
		minY: eventY - halfCardHeight,
		maxY: eventY + halfCardHeight
	};

	if (cardSize.minX < windowSize.minX) {
		left = windowSize.minX;
	} else if (cardSize.maxX > windowSize.maxX) {
		left = windowSize.maxX - width;
	} else {
		left = cardCenterX;
	}


	if (cardSize.minY < windowSize.minY) {
		top = windowSize.minY;
	} else if (cardSize.maxY > windowSize.maxY) {
		top = windowSize.maxY - height;
	} else {
		top = cardCenterY;
	}

	container.style.left = left + 'px';
	container.style.top = top + 'px';

	container.setAttribute('clickX', cardCenterX);
	container.setAttribute('clickY', cardCenterY);
	container.setAttribute('initialLeft', left);
	container.setAttribute('initialTop', top);
}

export function closePoiInfoWindowCardInOrbit(smoothClose = false, returnMapToBuilding = true) {
	if (settingsData.activeViewMode !== ViewMode.Orbit)
		return;

	const mainContainer = document.querySelector('.poi__info-window');
	if (!mainContainer)
		return;

	if (isMobile) {
		mainContainer.classList.remove('open-mobile-card');
		if (smoothClose) {
			setTimeout(() => {
				mainContainer.remove();
				mobileBurgerStyleToggle();
				resetMapRenderer();
				returnMapToBuilding && smoothlyAnimatePanTo(map, settingsData.mapCenter);
			}, 200);
		} else {
			mainContainer.remove();
			mobileBurgerStyleToggle();
			resetMapRenderer();
			returnMapToBuilding && smoothlyAnimatePanTo(map, settingsData.mapCenter);
		}
	} else {
		if (smoothClose) {
			poiCardAnimation('close');
			setTimeout(() => {
				mainContainer.remove();
				resetMapRenderer();
				returnMapToBuilding && smoothlyAnimatePanTo(map, settingsData.mapCenter);
			}, 200);
		} else {
			mainContainer.remove();
			resetMapRenderer();
			returnMapToBuilding && smoothlyAnimatePanTo(map, settingsData.mapCenter);
		}
	}
	closePrevInfoWindow();

	let poiLayer;

	if (Environment.isActive()) {
		poiLayer = Environment.getLayer('poi');
	} else {
		poiLayer = PublicLayers.getLayer('poi');
	}
	poiLayer && poiLayer.removeRoute();
}

export function setPoiCardSwipeFunctions(classVariable, ...args) {
	const dir = getCurrentLangDirection();
	classVariable.stop();
	if (!settingsData.isLandscape) {
		classVariable.onDown(() => {
			closePoiInfoWindowCardInOrbit(true)
		});
		classVariable.onUp(() => {
			openMiniCardFullscreen(args[0], true);
			args[1].classList.add('orbit__mode');
			mobileBurgerStyleToggle();
			classVariable.onDown = () => {
			};
		});
	} else {
		switch (dir) {
			case 'rtl':
				classVariable.onLeft(() => closePoiInfoWindowCardInOrbit(true));
				classVariable.onRight(() => {
					openMiniCardFullscreen(args[0], true);
					args[1].classList.add('orbit__mode');
					mobileBurgerStyleToggle();
					classVariable.onDown = () => {
					};
				});
				break;
			case 'ltr':
				classVariable.onRight(() => closePoiInfoWindowCardInOrbit(true));
				classVariable.onLeft(() => {
					openMiniCardFullscreen(args[0], true);
					args[1].classList.add('orbit__mode');
					mobileBurgerStyleToggle();
					classVariable.onDown = () => {
					};
				});
				break;
		}
	}
	classVariable.run();
}

function poiCardAnimation(action) {
	const card = document.querySelector('.poi__info-window');
	if (!card)
		return;

	// let left = isDesktop ? window.innerWidth - card.getBoundingClientRect().width - 37 : getCurrentLangDirection() === 'ltr' ? window.innerWidth - card.getBoundingClientRect().width - 37 : 37;

	const cardBounds = card.getBoundingClientRect();
	const windowBounds = TRoot.getBoundingClientRect();
	const menu = window.innerWidth - windowBounds.width;
	const clickX = parseFloat(card.getAttribute('clickX'));
	const clickY = parseFloat(card.getAttribute('clickY'));
	let left = clickX;
	let top = clickY;
	const padding = 10;

	if (clickX + cardBounds.width - menu > windowBounds.width) {
		left = menu + windowBounds.width - cardBounds.width + padding;
	} else if (clickX < windowBounds.x) {
		left = windowBounds.x + padding;
	}

	if (getCurrentLangDirection() === 'rtl') {
		if (clickX + cardBounds.width > windowBounds.width) {
			left = windowBounds.width - cardBounds.width - padding;
		}
	}

	if (clickY + cardBounds.height + 80 > windowBounds.height) {
		top = windowBounds.height - cardBounds.height - 80 - padding;
	} else if (clickY < 0) {
		top = padding;
	}

	switch (action) {
		case 'open':
			gsap.fromTo(card, {
				transform: 'scale(0)',
				left: card.getAttribute('clickX'),
				top: card.getAttribute('clickY')
			}, {
				left: left,
				// left: card.getAttribute('initialLeft'),
				// top: card.getAttribute('initialTop'),
				// top: 110,
				top: top,
				transform: 'scale(1)',
				duration: .2,
				delay: 0,
			});
			break;
		case 'close':
			gsap.to(card, {
				duration: .2,
				delay: 0,
				left: card.getAttribute('clickX'),
				top: card.getAttribute('clickY'),
				transform: 'scale(0)'
			});
			break;
	}
}

export function updateMapPanoramaInOrbit() {
	const container = document.querySelector('.map__panorama__orbit');
	if (!container)
		return;

	pageResize(container);
}

